import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { createBreadCrumbProps, formatRelativeTimeForTable, getAllKeyValues, useEffectOnce } from '../../../../globalUtils/globalHooks';
import {
	useAppDispatch,
	useAppSelector,
} from '../../../../rmsReduxStore/rmsReduxHooks';
import { clearAcChargerHistoryGraphData, fetchAcChargerConnectorStatusLogs, fetchAcChargerGraphDetail, fetchAcChargerGraphDetailBulk, fetchAcChargerMasterInfo, fetchAcChargerSettingsMasterInfo, fetchAcChargerStatusMasterInfo, fetchAcChargerStatusSystemInfo, fetchAcChargerSystemInfo, fetchAcChargerUptimeHistory, fetchAllowedAcCommandsForRole, fetchIndividualAcChargerDetail, setAcChargerHistoryGraphFilterHash } from '../../../rmsReduxStore/acChargersRedux/acChargerCreators';
import { useLocation  } from 'react-router-dom';
import {  getAcChargerReducer, getAcFilterReducer, getacNocDashboardReducer, getAcReferenceDataReducer } from '../../../rmsReduxStore/acReduxExports';

import { AutoRefresh, CustomBreadCrumbs, DashboardHeader, DashboardLoader, FilledChargerCards, HorizontalNavbar, SubHeaderChargerDetailCards } from '../../../../globalUtils/globalExports';
import { ChargerDetailSubHeaderCustomerOrgSkeleton, ChargerDetailSubHeaderSkeleton, ChargerPanelHeaderCardSkeleton, ChargerPanelHeaderSkeleton } from '../../../../globalUtils/SkeletonDesign/SkeletonDesign';
import moment from 'moment';
import access from '../../../../auth/service/AccessControl';
import { IconWithTooltip } from '../../../../globalUtils/globalIcons';
import { cloneDeep } from 'lodash';
import { fetchChargerHistoryIntervalReferenceData, getGlobalReducer, getReferenceDataReducer, setExpandedToggleIds } from '../../../../rmsReduxStore/reduxExports';
// import ChargerStatusParameters from '../../../../components/chargers/ChargerPanel/ChargerPanelStatus/ChargerStatusParameters';
import AcChargerStatusParameters from './AcChargerStatusParameters';
import AcChargerPanelSystemsInfoDashboard from './AcChargerPanelSystemsInfoDashboard';
import AcChargerPanelSettingsDashboard from './AcChargerPanelSettingsDashboard';
import AcChargerPanelRemoteCommandsDashboard from './AcChargerPanelRemoteCommandsDashboard';
import AcChargerPanelStatusSecondOption from './chargerPanelStatus/AcChargerPanelStatusSecondOption';
import { fetchAcChargerHistoryTypeReferenceData } from '../../../rmsReduxStore/acReferenceDataRedux/acReferenceDataCreator';
import { getAcFilterSelectedValue, getCurrentAcFiltersValues, setAcFilterData } from '../../../rmsReduxStore/acFiltersRedux/acFiltersCreators';
import AcChargerPanelAdminActionsDashboard from './chargerPanelStatus/AcChargerPanelAdminActionsDashboard';
import AcAlarmTable from '../../alarms/AcAlarmTable';
import {  fetchAcAlarmListData } from '../../../rmsReduxStore/acAlarmsRedux/acAlarmCreators';

const AcChargerPanelDashboard = memo(function AcChargerPanelDashboard() {
	const dispatch = useAppDispatch();
	const location = useLocation();
  const {nocDashboardChargerIdsForRedirection} = useAppSelector(getacNocDashboardReducer)
   const params = new URLSearchParams(location?.search)
  location.state = params?.get('redirectedFrom') === 'nocDashboard' ? {chargerId:nocDashboardChargerIdsForRedirection?.[0]} : location?.state
    //const navigate = useNavigate();
	const { individualChargerDetail,lastRefreshTime,chargerStatusMasterInfoAltered ,chargerStatusMasterInfo,chargerMasterInfo ,chargerHistoryUptime} = useAppSelector(getAcChargerReducer);
    const { chargerHistoryGraphData ,chargerSettingsMasterInfo} = useAppSelector(getAcChargerReducer);
    const { screenFilters } = useAppSelector(getAcFilterReducer)
    const { toggleExpandedIds } = useAppSelector(getGlobalReducer);
    const {chargerHistoryIntervalReferenceData } = useAppSelector(getReferenceDataReducer);
    const { chargerHistoryTypeReferenceData} = useAppSelector(getAcReferenceDataReducer);
    const chargerPanelHeaderCards = useRef<HTMLDivElement>(null);
    const chargerPanelHeader = useRef<HTMLDivElement>(null);
    const chargerPanel = useRef<HTMLDivElement>(null);
    const chargerPanelContentNavbar = useRef<HTMLDivElement>(null);
    const [contentHeight, setContentHeight] = useState(0);
    const [navbarHeight, setNavbarHeight] = useState(0);
    const [showLoader, setShowLoader] = useState(false);
    const chargerPanelParameterRef = useRef<HTMLDivElement>(null);
    const isOrgTypeCustomer = access?.isOrgTypeCustomer();
    type ChargerNav = 'status' | 'system_info' | 'settings' | 'remote_commands' | 'info_graphics' | 'admin_actions' | 'alarm_history';
    const [selectedNav, setSelectedNav] = useState<ChargerNav>(() => {
      const redirectedNav = params?.get('selectedNav') as ChargerNav;
      return ['settings', 'remote_commands'].includes(redirectedNav) ? redirectedNav : 'info_graphics';
    });
    const [chargerUptimeData, setChargerUptimeData] = useState<{
    headerText: string;
    headerArray: {
      title: string;
      value: string;
    }[]
  }[] | null>(null);


    useEffectOnce(() => {
			dispatch(fetchIndividualAcChargerDetail({chargerId: location?.state?.chargerId}));
			dispatch(fetchAcChargerHistoryTypeReferenceData({chargerId: location?.state?.chargerId,}));
      dispatch(fetchChargerHistoryIntervalReferenceData());	
      dispatch(fetchAcChargerUptimeHistory({ chargerId: location?.state?.chargerId }))
      // dispatch(fetchAcChargerGraphDetail({chargerId: location?.state?.chargerId,}));
    
    }
    );

  const apiCallBackOnRefresh = useCallback(async () => {
    apiCallForChargerStatusHistoryGraph();
    dispatch(fetchAcChargerUptimeHistory({ chargerId: location?.state?.chargerId }))
    dispatch(fetchIndividualAcChargerDetail({ chargerId: location?.state?.chargerId, }))
    apiCallbackForHistoryLogs();
  }, [])
  const breadCrumbs = createBreadCrumbProps({
    breadCrumbProps:
      [
        {
          objectType: 'link',
          id: 'chargers',
          link:'/ac/manage-chargers'
        },
        {
          objectType: 'text',
          id: 'text',
          text: location?.state?.charger?.visibleId || individualChargerDetail?.chargerVisibleId
        }
      ]
  })


  const chargerHeaderCards = useMemo(() => {
    const lastPingTime = individualChargerDetail?.lastPingTime && new Date(individualChargerDetail?.lastPingTime);
    const statusBackgroundColor = individualChargerDetail?.status ? individualChargerDetail?.status === 'Online' ? 'var(--card-green-color)' :( individualChargerDetail?.status === 'Offline' || individualChargerDetail?.status === 'RMS Disable') ? 'var(--grey-color)' : 'var(--grey-color))' : 'var(--grey-color))';
    const alarmBackgroundColor = (!individualChargerDetail?.alarmStatus || individualChargerDetail?.alarmStatus === 'No alarm') ? 'var(--green-color)' : individualChargerDetail?.alarmStatus === 'Critical' ? 'var(--critical-alarm-color)' : individualChargerDetail?.alarmStatus === 'Major' ? 'var(--major-alarm-color)' : 'var(--minor-alarm-color)';
    const LastPingBackgroundColor = lastPingTime ? Math.floor(((Math.abs(new Date(lastPingTime).valueOf() - new Date().valueOf())) / 1000) / 60) > 10 ? 'var(--card-grey-color)' : 'var(--charger-card-purple-color)' : 'var(--charger-card-purple-color)';

    return [
      {
        cardId: 'status',
        headerText: 'status',
        footerText: individualChargerDetail?.status ? individualChargerDetail?.status : '-',
        bgColor: statusBackgroundColor
      },
      {
        cardId: 'charger-model',
        headerText: 'chargerModel',
        footerText: individualChargerDetail?.model ? individualChargerDetail?.model : '-',
        footerSubText: individualChargerDetail?.modelDescription ? individualChargerDetail?.modelDescription : '-'
      },
      {
        cardId: 'last-ping',
        headerText: 'lastPing',
        footerText: lastPingTime && moment(lastPingTime).format('MMM Do') ? moment(lastPingTime).format('MMM Do') : '-',
        footerSubText: lastPingTime && moment(lastPingTime).format('LT') ? moment(lastPingTime).format('LT') : '',
        bgColor: LastPingBackgroundColor
      },
      {
        cardId: 'alarm-status',
        headerText: 'alarmStatus',
        footerText: individualChargerDetail?.alarmStatus ? individualChargerDetail?.alarmStatus : 'No Alarm',
        bgColor: alarmBackgroundColor

      },
      {
        cardId: 'software-version',
        headerText: 'softwareVersion',
        footerText: individualChargerDetail?.softwareVersion ? individualChargerDetail?.softwareVersion : '-',
        footerSubText: individualChargerDetail?.softwareVersionLastUpdatedOn ? formatRelativeTimeForTable(new Date(individualChargerDetail?.softwareVersionLastUpdatedOn)) : '-'
      }
    ]
  }, [individualChargerDetail])
  const calculateContentHeight = useCallback(() => {
    if (chargerPanel.current != null && chargerPanelHeader.current != null && chargerPanelHeaderCards.current != null && chargerPanelContentNavbar.current != null) {
      const panelRect = chargerPanel.current.getBoundingClientRect();
      // const headerRect = chargerPanelHeader.current.getBoundingClientRect();
      // const headerCardsRect = chargerPanelHeaderCards.current.getBoundingClientRect();
      const navbarRect = chargerPanelContentNavbar.current.getBoundingClientRect();
      const totalHeight = panelRect.height;
      // const headerHeight = headerRect.height;
      // const headerCardsHeight = headerCardsRect.height;
      const navbarHeight = navbarRect.height;
      setNavbarHeight(navbarHeight);
      // const remainingHeight = totalHeight - headerHeight - headerCardsHeight - 30;
      setContentHeight(totalHeight - 30);
    }
  }, [chargerPanel, chargerPanelHeader, chargerPanelHeaderCards, chargerPanelContentNavbar]);

  useEffect(() => {
    const ro = new ResizeObserver(() => {
      calculateContentHeight()
    })
    if (chargerPanel.current != null) {
      ro.observe(chargerPanel.current)
    }
    window.addEventListener('resize', calculateContentHeight)
    return (): void => {
      window.removeEventListener('resize', calculateContentHeight)
    }
  }, [chargerPanel])

  useEffect(() => {
    calculateContentHeight();
    window.addEventListener('resize', calculateContentHeight);
    return (): void => {
      window.removeEventListener('resize', calculateContentHeight);
    };
  }, [calculateContentHeight]);


  useEffect(()=>{
    dispatch(fetchAcChargerStatusMasterInfo({ chargerId: location?.state?.chargerId },true))
    dispatch(fetchAcChargerStatusSystemInfo({ chargerId: location?.state?.chargerId }))
    dispatch(fetchAcChargerSettingsMasterInfo({ chargerId: location?.state?.chargerId }))
    dispatch(fetchAcChargerMasterInfo({ chargerId: location?.state?.chargerId },true))
    dispatch(fetchAcChargerSystemInfo({ chargerId: location?.state?.chargerId }))
    dispatch(fetchAllowedAcCommandsForRole(location?.state?.chargerId))
  },[])


const handleNavClick = useCallback((event, val) => {
      setSelectedNav(val);
    }, []);

const handleExpandAndCollapse = useCallback((value: 'expand_all' | 'collapse_all') => {
        let array: string[] = cloneDeep(toggleExpandedIds)
        const data = (nav): ChargerMasterInfo[] | null => {
          switch (nav) {
            case 'status': return cloneDeep(chargerStatusMasterInfo); break;
            case 'system_info': return cloneDeep(chargerMasterInfo); break;
            case 'settings': return cloneDeep(chargerSettingsMasterInfo); break;
            
            default: return null; break;
          }
        }
        if (value === 'expand_all' && data && data !== null && data?.length > 0) {
          data(selectedNav)?.forEach(element => {
            const updatedKeys = getAllKeyValues(element, 'key');
            if (updatedKeys && updatedKeys?.length > 0) {
              array = [...array, ...updatedKeys]
            }
          })
        } else if (value === 'collapse_all') {
          array = []
        }
        dispatch(setExpandedToggleIds(array));
        if (selectedNav === 'status' && chargerPanelParameterRef && chargerPanelParameterRef?.current !== null) {
          chargerPanelParameterRef?.current?.scrollIntoView()
        }
      }, [selectedNav, chargerStatusMasterInfoAltered, toggleExpandedIds, chargerPanelParameterRef])

const navList = [
  {
    id: 'info_graphics',
    text: 'Infographics',
    isAccessible: access?.chargers?.view()
  },
  {
    id: 'status',
    text: 'Status',
    isAccessible: access?.chargers?.status?.view()
  },
  {
    id: 'system_info',
    text: 'System Info',
    isAccessible: access?.chargers?.systemInfo?.view()
  },
    {
    id: 'settings',
    text: 'Settings',
    isAccessible: access?.chargers?.settings?.view()
  },
    {
    id: 'remote_commands',
    text: 'Remote Commands',
    isAccessible: access?.chargers?.remoteCommands?.view()
  },
    {
    id: 'admin_actions',
    text: 'Admin Actions',
    isAccessible: access?.chargers?.admin?.view()
  },
    {
    id: 'alarm_history',
    text: 'Alarms',
    isAccessible: access?.alarms?.view()
  },
]



  const apiCallForChargerStatusHistoryGraph = useCallback(async () => {

		if (chargerHistoryGraphData) {
			await dispatch(clearAcChargerHistoryGraphData());
		}
		const selectedHistoryType = getAcFilterSelectedValue(
			'historyType',
			'acchargerPanel',
			false,
		);
		if (!selectedHistoryType) {


			const history = await dispatch(fetchAcChargerHistoryTypeReferenceData({ chargerId: location?.state?.chargerId }))


			const interval =	await dispatch(fetchChargerHistoryIntervalReferenceData());

			const historyType = history?.find(
				(item) => item?.defaultOption,
			);
			const statType = historyType?.statType?.find(
				(item) => item?.defaultOption,
			);
			const connectorType = historyType?.connectorType?.find(
				(item) => item?.defaultOption,
			);
			const historyInterval = interval?.find(
				(item) => item?.defaultOption,
			);
			const statInterval = historyInterval?.statInterval?.find(
				(item) => item?.defaultOption,
			);
			if (historyType) {
				await setAcFilterData(
					historyType,
					'historyType',
					'acchargerPanel',
					'SET',
					false,
				)(dispatch);
				await setAcFilterData(
					statType,
					'statType',
					'acchargerPanel',
					'SET',
					false,
				)(dispatch);
				await setAcFilterData(
					connectorType,
					'connectorId',
					'acchargerPanel',
					'SET',
					false,
				)(dispatch);
			}
			if (historyInterval) {
				await setAcFilterData(
					historyInterval,
					'historyInterval',
					'acchargerPanel',
					'SET',
					false,
				)(dispatch);
				await setAcFilterData(
					statInterval,
					'statInterval',
					'acchargerPanel',
					'SET',
					false,
				)(dispatch);
			}
			const filterHash = await dispatch(
				setAcChargerHistoryGraphFilterHash(
					'SET',
					historyType?.id,
					connectorType?.id,
				),
			);
			await dispatch(
				fetchAcChargerGraphDetail({
					chargerId: location?.state?.chargerId,
					filterHash: filterHash,
					filters: getCurrentAcFiltersValues('acchargerPanel', true),
				}),
			);
		} else {

			const resultAction =  await dispatch(fetchAcChargerHistoryTypeReferenceData({ chargerId: location?.state?.chargerId ,}))
			const previousSelectedConnectorTypes = getAcFilterSelectedValue(
				'connectorId',
				'acchargerPanel',
				false,
			)?.map((item) => item?.name);
			const connectorTypes = resultAction?.find(
				(item) => item.id === selectedHistoryType?.[0]?.id,
			)?.connectorType;
			const filteredConnectors =
				connectorTypes?.filter((item) =>
					previousSelectedConnectorTypes?.includes(item?.name),
				) ?? [];
			const connectorToSet =
				filteredConnectors?.length > 0
					? filteredConnectors
					: connectorTypes?.find((item) => item?.defaultOption);
			await setAcFilterData(
				connectorToSet,
				'connectorId',
				'acchargerPanel',
				'SET',
				false,
			)(dispatch);
			fetchAcChargerGraphDetailBulk({ chargerId: location?.state?.chargerId })(
				dispatch,
			);
		}
	}, [
		screenFilters,
		chargerHistoryTypeReferenceData,
		chargerHistoryIntervalReferenceData,
		chargerHistoryGraphData,
	]);

  const apiCallbackForHistoryLogs = useCallback(() => {
    const filters = getCurrentAcFiltersValues('acchargerPanel', true)
    dispatch(fetchAcChargerConnectorStatusLogs({ chargerId: location?.state?.chargerId, filters: filters?.filter((item) => item?.key === 'historyInterval') }))
  }, [screenFilters])

  const apiCallbackforAlarmHistoryLayoutCallback = useCallback(async (pageNumber: number, pageSize: number, view: string, field: string, order: string) => {
    const sortField = field === 'id' ? 'alarmId' : (field || 'alarmSetTime');
    await dispatch(fetchAcAlarmListData({
      pageSize: pageSize,
      pageNumber: pageNumber,
      fetchType: 'history',
      sortBy: sortField,
      order: order || 'descending',
      chargerId: location.state.chargerId
    }));

  }, [selectedNav, location]);

    useEffect(() => {
      if (chargerHistoryUptime) {
        const modifiedData = Object.keys(chargerHistoryUptime).map(key => {
          const element = chargerHistoryUptime[key];
          return {
            headerText: key === 'uptimeOfCharger'
              ? 'Uptime of Charger ' + (element?.unit ?? '')
              : key === 'chargerEnergy'
                ? 'Charger Energy'
                : key === 'chargingTime'
                  ? 'Charging Time'
                  : '',
            headerArray: [
              {
                title: '1 week',
                value: (element?.data?.oneWeek !== undefined && element?.data?.oneWeek !== null)
                  ? (key === 'chargingTime' ? element.data.oneWeek : element.data.oneWeek.toFixed(2) + element.unit)
                  : ' '
              },
              {
                title: '1 month',
                value: (element?.data?.oneMonth !== undefined && element?.data?.oneMonth !== null)
                  ? (key === 'chargingTime' ? element.data.oneMonth : element.data.oneMonth.toFixed(2) + element.unit)
                  : ' '
              },
              {
                title: '1 year',
                value: (element?.data?.oneYear !== undefined && element?.data?.oneYear !== null)
                  ? (key === 'chargingTime' ? element.data.oneYear : element.data.oneYear.toFixed(2) + element.unit)
                  : ' '
              }
            ]
          };
        });
        setChargerUptimeData(modifiedData)
      }
    }, [chargerHistoryUptime]);
	return <>
        <div ref={chargerPanel} className='charger__panel'>
          <DashboardLoader handleClose={setShowLoader} showLoader={showLoader} />
      <div ref={chargerPanelHeader} className='charger__panel-header-wrap'>
        <div className='back__btn-container'>
          <CustomBreadCrumbs breadCrumbs={breadCrumbs} />
        </div>
        {individualChargerDetail ?
          <div className='charger__panel-header'>
            <div className='charger__panel-header-content-wrap'>
              <DashboardHeader header={individualChargerDetail?.chargerVisibleId} />

              {individualChargerDetail?.orgType &&
                <>
                  <p className="charger__panel-sub-header-separator">|</p>
                  <p className="charger__panel-sub-header">Product Type: {individualChargerDetail?.productType ? individualChargerDetail?.productType : 'NA'}</p>
                </>
              }
              <p className="charger__panel-sub-header-separator">|</p>
              <p className="charger__panel-sub-header">Customer: {individualChargerDetail?.customerName}</p>
              {location?.state?.charger?.city &&
                <>
                  <p className="charger__panel-sub-header-separator">|</p>
                  <p className="charger__panel-sub-header">Location: {location?.state?.charger?.city}</p>
                </>
              }
            </div>
            <div className="charger__panel-bottom-auto-refresh-wrap">
              <AutoRefresh
                refreshDate={new Date(lastRefreshTime || '')}
                containerClassName="charger__auto__refresh__component"
                onRefreshCallback={apiCallBackOnRefresh}
                pathName="/charger"
                refreshLocation={false}
              />
            </div>
          </div>
          :
          <ChargerPanelHeaderSkeleton />}
      </div>

      <div ref={chargerPanelHeaderCards} className='charger__panel-cards-wrap'>
        {individualChargerDetail ?
          <div className='charger__panel-alarm-cards'>
            {chargerHeaderCards && chargerHeaderCards?.length > 0 && chargerHeaderCards?.map((chargerHeaderCard, index) => <FilledChargerCards key={'charger-card-' + index} cardId={chargerHeaderCard?.cardId} headerText={chargerHeaderCard?.headerText} footerText={chargerHeaderCard?.footerText} footerSubText={chargerHeaderCard?.footerSubText} bgColor={chargerHeaderCard?.bgColor} />)}
          </div> :
          <ChargerPanelHeaderCardSkeleton />
        }
        {isOrgTypeCustomer ?
                  (chargerHistoryUptime && chargerUptimeData ?
                    <SubHeaderChargerDetailCards headerArray={chargerUptimeData?.filter((item) => item.headerText === 'Uptime of Charger %')} containerClassName='' subHeaderCardId='charger-summary-key-header' />
                    : <ChargerDetailSubHeaderCustomerOrgSkeleton />)
                  : (chargerHistoryUptime && chargerUptimeData ? <SubHeaderChargerDetailCards headerArray={chargerUptimeData} containerClassName='' subHeaderCardId='charger-summary-key-header' />
                    : <ChargerDetailSubHeaderSkeleton />)
        }
       
      </div>
            <div className='charger__panel-detail-wrapper' style={{ height: `${contentHeight}px` }}>
        <div ref={chargerPanelContentNavbar} className='charger__panel-detail-navbar'>
          <HorizontalNavbar selectedNav={selectedNav} onNavClick={handleNavClick} navList={navList} />
          {(selectedNav === 'status' ||  selectedNav === 'system_info' || selectedNav === 'settings') &&
            <div className='charger__panel__expand__and__collapse__wrap'>
              <IconWithTooltip iconClassName='panel_expand_all_icon' toolTipText={'Expand All'}
                onIconClick={(e) => { e?.stopPropagation(); handleExpandAndCollapse('expand_all') }}
              />
              <IconWithTooltip iconClassName='panel_collapse_all_icon' toolTipText={'Collapse All'}
                onIconClick={(e) => { e?.stopPropagation(); handleExpandAndCollapse('collapse_all') }}
              />
            </div>
          }

        </div>
        {selectedNav === 'info_graphics' && <AcChargerPanelStatusSecondOption ref={chargerPanelParameterRef} apiCallForChargerStatusHistoryGraph={apiCallForChargerStatusHistoryGraph} apiCallbackForHistoryLogs={apiCallbackForHistoryLogs} contentHeight={contentHeight - navbarHeight} />}
        {selectedNav === 'status' && <AcChargerStatusParameters ref={chargerPanelParameterRef} contentHeight={contentHeight - navbarHeight} />}
        {selectedNav === 'system_info' && (<AcChargerPanelSystemsInfoDashboard contentHeight={contentHeight - navbarHeight} />)}
        {selectedNav === 'settings' && <AcChargerPanelSettingsDashboard contentHeight={contentHeight - navbarHeight} />}
        {selectedNav === 'remote_commands' && (<AcChargerPanelRemoteCommandsDashboard contentHeight={contentHeight - navbarHeight} />)}
        {selectedNav === 'alarm_history' && (<AcAlarmTable layoutCallback={apiCallbackforAlarmHistoryLayoutCallback} view={'list'} contentHeight={contentHeight - navbarHeight - 20} containerClassName='' calledFrom='charger_panel' id={location?.state?.chargerId} />)}
        {selectedNav === 'admin_actions' && (<AcChargerPanelAdminActionsDashboard contentHeight={contentHeight - navbarHeight} />)}

      </div>
      </div>
    </>;
});

export default AcChargerPanelDashboard;
